export default __webpack_public_path__ + "static/media/duplicate.06ed9766.svg";